import { SyncLoadingOverlay } from './SyncLoadingOverlay';

export { SyncLoadingOverlay };
export default SyncLoadingOverlay;
